import { PluginKey } from '@atlaskit/editor-prosemirror/state';

import type { SessionContextPluginState } from './types';

export const aiSessionContextPluginKey: PluginKey<SessionContextPluginState> =
	new PluginKey<SessionContextPluginState>('aiSessionContext');
